export const TEST_ID = 'cartTray';
